import isEmpty from "../../is-Empty";
import Validator from "validator";

export const MobileNumberValidation = (data) => {
  let errors = {};

  data.number = !isEmpty(data.number) ? data.number : "";

  if (!Validator.isLength(data.number, { min: 10, max: 10 })) {
    errors.number = "Enter 10 digits mobile number";
  }
  if (Validator.isEmpty(data.number)) {
    errors.number = "Mobile Number is Required";
  }

  return {
    errors,
    isValid: isEmpty(errors),
  };
};
